import { api } from "@config/axios/axios.config";
import { showNotification } from "@libs/notistack/notificationStack";
import { HTTP_STATUS } from "@constants/http.status.code";
import { SERVER_ROUTES } from "@constants/api.routes";
import { SNACKBAR_SEVERITY } from "@constants/notificationStack";
import { getTranslation } from "@utils/translation";

export async function markNotificationReadService(id: string) {
  const res = await api.put(SERVER_ROUTES.NOTIFICATIONS.READ(id));

  // Handle feature-specific error (e.g., API returns success: false)
  if (res?.data && res?.data?.success === false) {
    showNotification({
      message: res.data?.message || getTranslation("psdaCommon.notifications.api.errors.markAsRead.failed"),
      severity: SNACKBAR_SEVERITY.ERROR,
    });
    throw new Error(res.data?.message || getTranslation("psdaCommon.notifications.api.errors.markAsRead.failed"));
  }

  // Success
  if (res?.data?.statusCode === HTTP_STATUS.OK || res?.data?.statusCode === HTTP_STATUS.CREATED) return id;
} 